import { getPostSignatureForOssUpload } from '@/api/file/file';
const OSS = require("ali-oss");
export async function getOSSConfig() {
    let config = JSON.parse(localStorage.getItem("ossConfig"));
    if (config) {
        const now = Date.now() / 1000;
        const expireTime = config.expireTime || now;
        // 后端提前10分钟失效，这里提前5分钟失效
        if (expireTime - now > 300) {
            return config;
        }
    }
    const res = await getPostSignatureForOssUpload();
    if (res.code === "0") {
        config = res.data;
        config.storageTime = Date.now();
        localStorage.setItem("ossConfig", JSON.stringify(res.data));
    }
    return config;
}

export function getOSSClient(ossConfig) {
    const client = new OSS({
        accessKeyId: ossConfig.accessKeyId,
        accessKeySecret: ossConfig.accessKeySecret,
        stsToken: ossConfig['x-oss-security-token'],
        bucket: ossConfig.bucket,
        region: 'oss-' + ossConfig.region,
        refreshSTSTokenInterval: 0, // 由Credential控制accessKeyId、accessKeySecret和stsToken值的更新
    });
    return client;
}

export async function getFileUrl(path) {
    if (!path || path === "") {
        return null;
    }
    let ossConfig = await getOSSConfig();
    const client = getOSSClient(ossConfig);
    const url = client.signatureUrl(path, {
        // 如果您希望生成的签名URL可以应用图片样式的效果，您可以通过process参数指定样式，格式为style/样式名称。
        // process: "style/imagestyle",
    });
    return url;
}

export function generateRandomFileName() {
    const timestamp = Date.now(); // 获取当前时间的时间戳
    const number = Math.floor(Math.random() * 100000); // 生成一个[0, 100000)的随机数
    return `${timestamp}${number.toString().padStart(5, '0')}`;
}

export async function downloadFile(url, filename) {
    const blob = await getBlob(url);
    saveAs(blob, filename);
}

function getBlob(url) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        xhr.onload = function () {
            if (this.status === 200) {
                resolve(this.response);
            } else {
                reject(new Error('Failed to download file'));
            }
        };
        xhr.onerror = () => {
            reject(new Error('Failed to download file'));
        }
        xhr.send();
    });
}

export async function saveAs(blob, filename) {
    let link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = filename
    link.style.display = 'none'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(link.href)
}